import { SlideshowSelectEvent } from '@theme/events';

// home_collection_click and home_carousel_swipe (location_id 'home_collections') on the collections grid,
// as live's nk_home_mobile_events.js. A swipe is one gesture's run of scroll/drag slide changes, reported once it settles.
const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();
const linkPath = (href) => {
  const url = new URL(href, location.origin);
  return url.origin === location.origin ? url.pathname + url.search : url.href;
};
const push = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
const pointX = (event) => (event.touches?.[0] || event.changedTouches?.[0] || event).clientX || 0;

let dragUntil = 0; // a click the browser fires at the end of a mouse drag is not a tap
let startX = 0;
let pointerDown = false;
let pendingSwipe = null;
let swipeTimer = 0;

const flushSwipe = () => {
  clearTimeout(swipeTimer);
  swipeTimer = setTimeout(() => {
    if (pointerDown || !pendingSwipe) return; // a finger still on the strip is the same swipe
    const { fromIndex, toIndex } = pendingSwipe;
    pendingSwipe = null;
    if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;
    push({ event: 'home_carousel_swipe', location_id: 'home_collections', direction: toIndex > fromIndex ? 'left' : 'right', tile_index: toIndex + 1 });
  }, 150);
};

const press = (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const slider = target?.closest('.eq-modern-grid-slider');
  if (!slider || target.closest('.slideshow-control, .eq-modern-grid-slider__pagination')) return;
  startX = pointX(event);
  pointerDown = true;
};

const release = (event) => {
  if (!pointerDown) return;
  pointerDown = false;
  if (Math.abs(pointX(event) - startX) > 10) dragUntil = Date.now() + 400;
  if (pendingSwipe) flushSwipe();
};

document.addEventListener(SlideshowSelectEvent.eventName, (event) => {
  const { detail } = event;
  if (!detail?.userInitiated || (detail.trigger !== 'scroll' && detail.trigger !== 'drag')) return;
  if (!(event.target instanceof Element) || !event.target.closest('.eq-modern-grid-slider')) return;
  if (pendingSwipe) pendingSwipe.toIndex = detail.index;
  else pendingSwipe = { fromIndex: detail.previousIndex, toIndex: detail.index };
  flushSwipe();
});

['touchstart', 'mousedown'].forEach((name) => document.addEventListener(name, press, { capture: true, passive: true }));
['touchend', 'touchcancel', 'mouseup'].forEach((name) => document.addEventListener(name, release, { capture: true, passive: true }));

document.addEventListener('click', (event) => {
  if (Date.now() < dragUntil) return;
  const link = event.target instanceof Element ? event.target.closest('.eq-modern-grid-slider .eq-modern-grid-card a[href]') : null;
  if (!link) return;
  const card = link.closest('.eq-modern-grid-card');
  push({
    event: 'home_collection_click',
    location_id: 'home_collections',
    collection_name: clean((card.querySelector('.eq-modern-grid-card__title') || link).textContent),
    link_url: linkPath(link.getAttribute('href')),
    tile_position: [...link.closest('.eq-modern-grid-slider').querySelectorAll('.eq-modern-grid-card')].indexOf(card) + 1,
  });
}, true);
